import { render, staticRenderFns } from "./Vaccine.vue?vue&type=template&id=e38676da&"
import script from "./Vaccine.vue?vue&type=script&lang=js&"
export * from "./Vaccine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports